// Service page content for Sponsored Family Visitor (Subclass 600, Sponsored
// Family stream). Sourced from docs/research/australian-visa-pathways.md §8.
// COMPLIANCE: we prepare and coordinate; a registered migration agent advises,
// confirms eligibility and fit, and lodges. No guarantees; honest about the
// bond and No Further Stay.

const sponsoredFamilyVisitor = {
  groupSlug: "visitor-working-holiday",
  slug: "sponsored-family-visitor",
  title: "Sponsored Family Visitor Visa",
  eyebrow: "Visitor & Working Holiday",
  intro:
    "The Sponsored Family stream of the visitor visa lets a settled Australian relative sponsor a family member to visit. Having a sponsor can strengthen an application where ties or funds are a concern, though the sponsor takes on real obligations and may need to lodge a security bond.",

  chips: [
    { label: "Visa type", value: "Visitor, Sponsored Family stream" },
    { label: "Sponsor", value: "A settled Australian relative" },
    { label: "May require", value: "A security bond" },
    { label: "Condition", value: "Often No Further Stay (8503)" },
  ],

  whoFor: [
    "Families wanting to bring a relative to visit Australia.",
    "Applicants whose visit is stronger with a sponsor backing it.",
    "Sponsors who understand and accept the obligations involved.",
  ],

  essentials: [
    {
      title: "An eligible sponsor",
      detail:
        "The sponsor is usually a settled Australian citizen, permanent resident, or eligible New Zealand citizen, generally an adult who has been settled for a couple of years.",
    },
    {
      title: "A formal sponsorship",
      detail:
        "The sponsor formally commits to support the visit and the visitor's compliance with their visa.",
    },
    {
      title: "A possible security bond",
      detail:
        "The Department may require the sponsor to lodge a security bond as security that the visitor leaves on time. The amount is set case by case.",
    },
    {
      title: "A genuine, temporary visit",
      detail:
        "As with any visitor visa, the visit must be genuine and temporary.",
    },
    {
      title: "Condition 8503, No Further Stay",
      detail:
        "This stream commonly carries No Further Stay, which prevents most onshore applications during the visit.",
    },
    {
      title: "Health and character",
      detail:
        "Standard health and character requirements apply to the visitor.",
    },
  ],

  process: [
    {
      title: "Check sponsor and visitor",
      detail:
        "A registered migration agent confirms the sponsor is eligible and that the sponsored stream is the right fit.",
    },
    {
      title: "Prepare the sponsorship",
      detail:
        "We help the sponsor see their obligations in writing and organise the sponsorship documents correctly.",
    },
    {
      title: "Plan for a bond if needed",
      detail:
        "Where a security bond is likely, we prepare the sponsor for it in advance.",
    },
    {
      title: "Lodge the application",
      detail:
        "We build a complete, submission-ready file, and a registered migration agent lodges it and manages correspondence with the Department.",
    },
    {
      title: "Explain the conditions",
      detail:
        "A registered migration agent explains the visa conditions to sponsor and visitor before travel, and we make sure the paperwork reflects them.",
    },
  ],

  faqs: [
    {
      q: "When should I use the sponsored stream?",
      a: "It can help where the Department might otherwise doubt funds or incentives to return home, because a settled Australian relative is formally backing the visit. A registered migration agent advises whether the sponsored stream or a standard tourist application is stronger for you.",
    },
    {
      q: "What is the security bond?",
      a: "The Department may ask the sponsor to lodge a refundable security bond as security that the visitor will leave on time. It is returned if the visa conditions are met. The amount is decided case by case, so we prepare the sponsor for the possibility.",
    },
    {
      q: "What obligations does the sponsor take on?",
      a: "The sponsor commits to supporting the visit and the visitor's compliance with their visa, and may be financially responsible through the bond. We make sure the sponsor sees this in writing, and a registered migration agent explains the legal effect before they commit.",
    },
    {
      q: "Can the visitor change to another visa while here?",
      a: "Usually not. The No Further Stay condition commonly applies, blocking most onshore applications. A registered migration agent explains exactly what is allowed before the visit.",
    },
  ],

  related: ["visitor-600", "working-holiday", "partner-visa"],

  lastVerified: "13 July 2026",
};

export default sponsoredFamilyVisitor;
